import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Paragraph, Heading, Button, Link } from 'components';
import './ServiceTile.scss';

const renderTile = ({
  title,
  caption,
  description,
  backgroundColor,
  textColor,
  link,
  alignedLeft,
  additionalClass,
}) => {
  const alignClass = alignedLeft
    ? 'service-tile--left w-container--left'
    : 'service-tile--right';

  return (
    <div
      className={`service-tile service-tile--${backgroundColor} ${alignClass} ${additionalClass}`}
    >
      <div className={'service-tile__content anim-fade-in-bottom'}>
        {caption && (
          <Paragraph
            color={textColor}
            additionalClass={'service-tile__caption'}
          >
            {caption}
          </Paragraph>
        )}
        <Heading
          size={'big'}
          type={2}
          color={textColor}
          additionalClass={'service-tile__header'}
        >
          {ReactHtmlParser(title)}
        </Heading>
        <Paragraph
          color={textColor}
          additionalClass={'text--light service-tile__description'}
        >
          {description}
        </Paragraph>
        {link && (
          <Button order={'secondary'} color={textColor}>
            Discover
          </Button>
        )}
      </div>
    </div>
  );
};

const ServiceTile = props => (
  <>
    {props.link ? (
      <Link to={props.link} arrow>
        {renderTile(props)}
      </Link>
    ) : (
      renderTile(props)
    )}
  </>
);

renderTile.defaultProps = {
  backgroundColor: 'white',
  textColor: 'black',
  additionalClass: '',
  alignedLeft: false,
  link: '',
};

renderTile.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  link: PropTypes.string,
  alignedLeft: PropTypes.bool,
  additionalClass: PropTypes.string,
};

export default ServiceTile;
